import {
  createCompobotGuiVersion,
  editCompobotGuiVersion,
} from 'services/compobotGuiVersions.service';
import {
  CompobotGuiVersionType,
  CreateGuiVersionType,
} from 'types/compobotGuiVersion.type';

export const createCustomParams = (
  isFullCustom: boolean,
  editedData: CreateGuiVersionType,
  colors: { pretext: string; title: string; subtitle: string; overlay: string },
  data?: CompobotGuiVersionType | null,
) => {
  if (isFullCustom && data) {
    return {
      ...data.jsonGuiDescriptor.GUIConfiguration.customParams,
      compobot_name: editedData.compobotName,
      logo: editedData.logoPath,
      dynamicPage: {
        ...data.jsonGuiDescriptor.GUIConfiguration.customParams.dynamicPage,
        qr: {
          en: editedData.qrCodeEn,
          hu: editedData.qrCodeHu,
          top: data.jsonGuiDescriptor.GUIConfiguration.customParams.dynamicPage
            .qr.top,
          left: data.jsonGuiDescriptor.GUIConfiguration.customParams.dynamicPage
            .qr.left,
        },
        title: {
          en: editedData.titleEn,
          hu: editedData.titleHu,
          color: colors.title,
        },
        pretext: {
          en: editedData.pretextEn,
          hu: editedData.pretextHu,
          color: colors.pretext,
        },
        subtitle: {
          en: editedData.subtitleEn,
          hu: editedData.subtitleHu,
          color: colors.subtitle,
        },
        display_date: {
          from: editedData.from,
          to: editedData.to,
        },
        overlay_color: colors.overlay,
        template_type: editedData.templateType,
        backgroundImageSrc: editedData.backgroundImage,
      },
    };
  }

  if (isFullCustom && !data) {
    return {
      logo: editedData.logoPath,
      dynamicPage: {
        qr: {
          en: editedData.qrCodeEn,
          hu: editedData.qrCodeHu,
          top: '50%',
          left: '50%',
        },
        title: {
          en: editedData.titleEn,
          hu: editedData.titleHu,
          color: colors.title,
        },
        pretext: {
          en: editedData.pretextEn,
          hu: editedData.pretextHu,
          color: colors.pretext,
        },
        subtitle: {
          en: editedData.subtitleEn,
          hu: editedData.subtitleHu,
          color: colors.subtitle,
        },
        display_date: {
          from: editedData.from,
          to: editedData.to,
        },
        overlay_color: colors.overlay,
        template_type: editedData.templateType,
        backgroundImageSrc: editedData.backgroundImage,
      },
      compobot_name: editedData.compobotName,
      selectedNumber: 5,
    };
  }

  return {
    logo: editedData.logoPath || '',
    dynamicPage: {
      qr: { en: '', hu: '', top: '50%', left: '50%' },
      title: { en: '', hu: '', color: '#ffffff' },
      pretext: { en: '', hu: '', color: '#ffffff' },
      subtitle: { en: '', hu: '', color: '#ffffff' },
      display_date: { from: '', to: '' },
      overlay_color: '#000000',
      template_type: 'theme_01',
      backgroundImageSrc: '',
    },
    compobot_name: editedData.compobotName,
    selectedNumber: 5,
  };
};

export const handleFormSubmit = (
  editedData: CreateGuiVersionType,
  useCustomPageParams: boolean,
  colors: { pretext: string; title: string; subtitle: string; overlay: string },
  data?: CompobotGuiVersionType | null,
) => {
  if (data) {
    const finalData: CompobotGuiVersionType = {
      ...data,
      name: editedData.guiName,
      description: editedData.description,
      jsonGuiDescriptor: {
        ...data.jsonGuiDescriptor,
        GUIConfiguration: {
          ...data.jsonGuiDescriptor.GUIConfiguration,
          app: {
            ...data.jsonGuiDescriptor.GUIConfiguration.app,
            name: editedData.compobotName,
            version: '4.0.0',
            defaultLanguage: editedData.language,
          },
          socketUrl: 'http://localhost:3001',
          customParams: createCustomParams(
            useCustomPageParams,
            editedData,
            colors,
            data,
          ),
          socketOptions: {
            timeout: 20000,
            forceNew: false,
            transports: ['websocket', 'polling'],
          },
        },
      },
    };

    editCompobotGuiVersion(finalData);
  } else {
    const currentTime = new Date().toISOString();
    const expirationTime = new Date(
      Date.now() + 365 * 24 * 60 * 60 * 1000,
    ).toISOString();

    const newData = {
      name: editedData.guiName,
      description: editedData.description,
      updateTime: currentTime,
      expirationTime: expirationTime,
      createdAt: currentTime,
      modifiedAt: currentTime,
      checksum: null,
      jsonGuiDescriptor: {
        GUIConfiguration: {
          app: {
            name: editedData.compobotName,
            version: '4.0.0',
            defaultLanguage: editedData.language,
            supportedLanguages: ['en', 'hu'],
          },
          socketUrl: 'http://localhost:3001',
          customParams: createCustomParams(
            useCustomPageParams,
            editedData,
            colors,
          ),
          socketOptions: {
            timeout: 20000,
            forceNew: false,
            transports: ['websocket', 'polling'],
          },
        },
      },
    };

    createCompobotGuiVersion(newData);
  }
};
